// extracted by mini-css-extract-plugin
export default {"MainCont":"Chilling_MainCont__SXHbs","LeftCont":"Chilling_LeftCont__hdDBm","RightCont":"Chilling_RightCont__2++2O"};